import { UserX } from "lucide-react";
import { useAuth } from "../contexts/auth-context";

export default function NoAccountPage() {
  const { signOut, user } = useAuth();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center text-center px-4">
      <UserX className="h-16 w-16 text-muted-foreground mb-4" />
      <h1 className="text-2xl font-bold mb-2">No Account Found</h1>
      <p className="text-muted-foreground mb-2 max-w-md">
        You&apos;re signed in
        {user?.email ? (
          <>
            {" "}
            as <span className="font-medium text-foreground">{user.email}</span>
          </>
        ) : null}
        , but there is no account associated with your login.
      </p>
      <p className="text-muted-foreground mb-6 max-w-md">
        Please contact your administrator to request an invitation, or sign in
        with a different email address.
      </p>
      <button
        onClick={() => signOut()}
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
      >
        Sign Out
      </button>
    </div>
  );
}
